import {
    mapGetters
} from 'vuex';

export const utilsMixin = {
    mounted() {},
    activated() {},
    methods: {
        isGoUp(numStr) {
            return +numStr >= 0;
        },
        hanleClickToPage(uri, type) {
            if (type) {
                this.$router.push(uri)
            } else {
                // window.location.href = 'https://mobile.aigupiao.com/Lives/lives_search.html'
                window.location.href = uri
            }
        },
        strToTimeStr(str) {
            let minuteStr = Math.floor(+str / 60);
            let secondStr = +str % 60;
            minuteStr = minuteStr < 10 ? '0' + minuteStr : minuteStr;
            secondStr = secondStr < 10 ? '0' + secondStr : secondStr;
            return minuteStr + ':' + secondStr;
        },
        twoDecimalPlaces(str) {
            if (isNaN(str)) {
                return '请传入数字字符串';
            } else {
                if (str.indexOf('.') > 0) {
                    return (+str).toFixed(2);
                } else {
                    return (+str)
                }
            }
        }
    }
};